module.exports = __webpack_public_path__ + "static/accommodation-87e0283cbb27f6e6f6dcea7415bba121.png";